export default {
      id: "qr-code-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "/gfx/iconset.13.17.6.svg#qr-code",
      toString: function () {
        return this.url;
      }
    }